import { useEffect } from 'react';

import Image from 'next/image';

import Typography from '@components/Typography';
import { HotelEventsViewModel } from '@api/v3';
import CustomIcon from '@components/utils/CustomIcon';
import { ProfileReservation, CloseIcon } from '@assets/icons';
import { FlexibleDiv } from '@components/formStyles';
import { groupDatesByMonth } from '@components/views/hotel/listing/components/Events/helpers';
import Markdown from '@components/utils/Markdown';

import {
  ContentWrapper,
  FlexDatesWrapper,
  Header,
  ImageWrapper,
  Main,
  ModalWrapper,
  SingleDateWrapper,
  Wrapper,
} from './styled';

type Props = Partial<HotelEventsViewModel> & {
  toggleDetailModal: () => void;
};

const EventDetailModal = ({
  title,
  image,
  shortDescription,
  dates = [],
  toggleDetailModal,
  description,
}: Props) => {
  useEffect(() => {
    const body = document.querySelector('body');

    if (body) {
      body.style.overflow = 'hidden';
    }

    return () => {
      if (body) {
        body.style.overflow = 'initial';
      }
    };
  }, []);

  return (
    <ModalWrapper>
      <Wrapper>
        <Header>
          <Typography variant='Title4' weight='SemiBold' color='D400'>
            <Markdown text={title} />
          </Typography>

          <CustomIcon
            icon={CloseIcon}
            fontSize={24}
            paletteColor='D400'
            clickable
            onClick={toggleDetailModal}
          />
        </Header>

        <Main>
          <ImageWrapper>
            <Image
              src={image ?? ''}
              alt={title ?? ''}
              width={200}
              height={200}
            />
          </ImageWrapper>

          <ContentWrapper>
            <FlexibleDiv bottom={8}>
              <Typography variant='caption2' weight='Regular' color='D400'>
                <Markdown text={shortDescription} />
              </Typography>
            </FlexibleDiv>

            <SingleDateWrapper>
              <FlexDatesWrapper>
                <CustomIcon
                  icon={ProfileReservation}
                  fontSize={24}
                  paletteColor='D400'
                />

                <Typography variant='caption2' weight='Regular' color='D400'>
                  {groupDatesByMonth(dates)}
                </Typography>
              </FlexDatesWrapper>
            </SingleDateWrapper>

            {description ? (
              <>
                <FlexibleDiv bottom={4}>
                  <Typography variant='caption1' weight='SemiBold' color='D400'>
                    Bilgiler
                  </Typography>
                </FlexibleDiv>

                <Typography variant='caption2' weight='Regular' color='D400'>
                  <Markdown text={description} />
                </Typography>
              </>
            ) : null}
          </ContentWrapper>
        </Main>
      </Wrapper>
    </ModalWrapper>
  );
};

export default EventDetailModal;
